/* LEADS & COLLARS — storefront navigation fallback */
(function(){
  if(window.Shopify&&window.Shopify.designMode)return;

  window.addEventListener('click',function(event){
    if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    var target=event.target;
    if(!(target instanceof Element))return;
    var link=target.closest('.lc-home a[href]');
    if(!link||link.target==='_blank'||link.hasAttribute('download'))return;

    var href=link.getAttribute('href');
    if(!href||href.indexOf('javascript:')===0)return;

    if(href.charAt(0)==='#'){
      var section=document.querySelector(href);
      if(!section)return;
      event.preventDefault();
      section.scrollIntoView({behavior:'smooth',block:'start'});
      try{history.replaceState(null,'',href);}catch(e){}
      return;
    }

    event.preventDefault();
    var destination=new URL(link.href,window.location.href);
    var current=new URL(window.location.href);
    ['preview_theme_id','_fd','pb'].forEach(function(key){
      if(current.searchParams.has(key)&&!destination.searchParams.has(key)){
        destination.searchParams.set(key,current.searchParams.get(key));
      }
    });
    window.location.assign(destination.href);
  },true);
})();
